import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
	PRODUCT_QUALITIES_DELETE,
	PRODUCT_QUALITIES_ADD,
	PRODUCTS_QUALITIES,
	GET_PRODUCT_QUALITIES_ROW_DATA,
} from "./actionTypes";
import {
	apiError,
	getProductQualities,
	ProductQualitiesListSuccessful,
	ProductQualitiesAddSuccessful,
	ProductQualitiesRowSuccessful,
} from "./action";

// AUTH related methods
import {
	postAdd,
	getList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getQualitiesProduct({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getList,
			"/masters/productqualities/",
			params
		);
		yield put(ProductQualitiesListSuccessful({ response }));
	} catch (error) {
		yield put(apiError(error));
	}
}
//If user is login then dispatch redux action's are directly from here.
function* AddQualityProduct({ payload: { data, id, history } }) {
	try {
		if (id === 0) {
			const response = yield call(
				postAdd,
				"/masters/productqualities/",
				data
			);
			if (response.status === 201) {
				swal("YourQuality Added Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getProductQualities());
			} else {
				swal("Sorry! Unable to add Quality. Please Try Again!", {
					icon: "error",
				});
			}
			history.push("/product/quality");
			yield put(ProductQualitiesAddSuccessful(null));
		} else {
			const response = yield call(
				postEdit,
				"/masters/productqualities/" + id + "/",
				data
			);
			if (response.status === 200) {
				swal("Your Quality Edited Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getProductQualities());
			} else {
				swal("Sorry! Unable to edit Quality. Please Try Again!", {
					icon: "error",
				});
			}
			history.push("/product/quality");
			yield put(ProductQualitiesAddSuccessful(null));
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		//yield put(apiError(error));
	}
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteQualityProduct({ payload }) {
	try {
		const response = yield call(
			postDelete,
			"/masters/productqualities/" + payload.id + "/"
		);

		if (response?.status === 204) {
			swal("Your Quality has been deleted!", {
				icon: "success",
				timer: 1500,
			});
			yield put(getProductQualities());
		} else {
			swal("Sorry! Your Quality was not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", { icon: "error" });
		yield put(apiError(error));
	}
}

function* GetProductQualityRowData({ payload }) {
	try {
		const response = yield call(
			getList,
			`/masters/productqualities/${payload.id}/`
		);

		const formattedResponse = {
			...response,
			product_id: response.product?.id || 0,
			productLabel: response.product?.name || "",
			quality_ids: Array.isArray(response.qualities)
				? response.qualities.map((q) => q.id)
				: [],
			qualityLabel: Array.isArray(response.qualities)
				? response.qualities.map((q) => q.name)
				: [],
		};

		yield put(
			ProductQualitiesRowSuccessful({
				response: formattedResponse,
			})
		);
	} catch (error) {
		yield put(apiError(error));
	}
}

export function* watchgetProductQualitiesProduct() {
	yield takeEvery(PRODUCTS_QUALITIES, getQualitiesProduct);
}
export function* watchQualityProductAdd() {
	yield takeEvery(PRODUCT_QUALITIES_ADD, AddQualityProduct);
}

export function* watchQualityProductDelete() {
	yield takeEvery(PRODUCT_QUALITIES_DELETE, DeleteQualityProduct);
}

export function* watchGetProductQualityRowData() {
	yield takeEvery(GET_PRODUCT_QUALITIES_ROW_DATA, GetProductQualityRowData);
}

function* QualityProductSaga() {
	yield all([
		fork(watchgetProductQualitiesProduct),
		fork(watchQualityProductAdd),
		fork(watchQualityProductDelete),
		fork(watchGetProductQualityRowData),
	]);
}

export default QualityProductSaga;
